module.exports = __webpack_public_path__ + "static/img/twitter_icon.ada3f86.svg";